import {type Channel, ChannelType} from '@mattermost/types/channels';

/**
 *
 * @deprecated используйте channel.type === ChannelType.Private
 */
export const isPrivateChannel = (channel: Channel | undefined) => {
    return channel?.type === ChannelType.Private;
};
